<template>
<div class="pageContainer">
  <div v-show="indexPage" class="activity">
    <div
      v-show="loading"
      class="loading"
    >
      <img
        v-show="foamRubber"
        src="../assets/images/insects/loadingbg.png"
      >
      <div class="activityTitle"><img src="../assets/images/insects/logo.png"></div>
      <div class="box">
        <div class="loader4"></div>
      </div>
    </div>
    <div
      id="music"
      :class="{rotate:!musicPause}"
      @click="musicPlay"
    >
      <img
        v-show="foamRubber"
        src="../assets/images/FoamRubber.mp3"
      >
      <img
        v-show='!musicPause'
        src="../assets/images/insects/icon_bgm.png"
      >
      <img
        v-show='musicPause'
        src="../assets/images/insects/icon_bgm_stop.png"
      >
      <audio
        id="media"
        loop="loop"
        src="../assets/images/FoamRubber.mp3"
        autoplay="autoplay"
        preload=""
      ></audio>
    </div>
    <div class="about">
      <div
        class="glassPlace01"
        v-show='glassActive==1'
        @click="question(0)"
      >
        <img src="../assets/images/insects/magnifier.png">
      </div>
      <div
        class="magnifglass glassPlace02"
        v-show='glassActive==2'
        @click="question(1)"
      >
        <img src="../assets/images/insects/magnifier.png">
      </div>
      <div
        class="magnifglass glassPlace03"
        v-show='glassActive==3'
        @click="question(2)"
      >
        <img src="../assets/images/insects/magnifier.png">
      </div>
      <div
        class="magnifglass glassPlace04"
        v-show='glassActive==4'
        @click="question(3)"
      >
        <img src="../assets/images/insects/magnifier.png">
      </div>
      <div
        class="tvBox"
        v-show="tvNews"
        @click="tvBox"
      >
        <img src="../assets/images/insects/tv.png">
      </div>
      <div
        class="tvMask"
        v-show="tvFlag"
      >
        <img
          class="news"
          src="../assets/images/insects/news.png"
        >
      </div>
      <div
        class="rightPlace01"
        v-show="correctActive1==1"
      >
        <img src="../assets/images/insects/right.png">
      </div>
      <div
        class="rightIcon rightPlace02"
        v-show="correctActive2==2"
      >
        <img src="../assets/images/insects/right.png">
      </div>
      <div
        class="rightIcon rightPlace03"
        v-show="correctActive3==3"
      >
        <img src="../assets/images/insects/right.png">
      </div>
      <div
        class="rightIcon rightPlace04"
        v-show="correctActive4==4"
      >
        <img src="../assets/images/insects/right.png">
      </div>
    </div>
    <div class="activityTipBox">
      <div class="activieContainer">
        <div class="activieTip">
          <div
            v-show="tipFlag"
            class="tip"
          >
            <span class="typedGuide"></span>
          </div>
          <div
            v-show="tipErrorFlag"
            class="tip"
          >
            <img
              class="answer_error"
              src="../assets/images/insects/answer_error.png"
            >
            <div>再仔细调查一下混知调查局的<br>档案和音频情报！<br><span class="redColor">点击放大镜</span>，重新答题！</div>
            <!-- <span class="answer05"></span> -->
          </div>
          <div
            v-show="tipTvFlag"
            class="tip"
          >
            <span class="answer06">这么重要的线索，<br /><span>点击放大镜</span>，赶紧去看看吧！看来很快就能抓住那个疑犯了！</span>
          </div>
          <div
            v-show="correctActive==1"
            class="correctTip"
          >
            <img
              class="answer_error"
              src="../assets/images/insects/answer_right.png"
            >
            <div><span class="answer01"></span></div>
          </div>
          <div
            v-show="correctActive==2"
            class="correctTip"
          >
            <img
              class="answer_error"
              src="../assets/images/insects/answer_right.png"
            >
            <div><span class="answer02"></span></div>
          </div>
          <div
            v-show="correctActive==3"
            class="correctTip"
          >
            <img
              class="answer_error"
              src="../assets/images/insects/answer_right.png"
            >
            <div><span class="answer03"></span></div>
          </div>
          <div
            v-show="correctActive==4"
            class="correctTip"
          >
            <img
              class="answer_error"
              src="../assets/images/insects/answer_right.png"
            >
            <div><span class="answer04"></span></div>
          </div>
        </div>
        <div class="activieHunzi">
          <img
            @click="shake"
            :class="{shake:shakeFlag}"
            src="../assets/images/insects/img_stone.png"
          >
        </div>
      </div>
    </div>
    <div class="bottomBox">
      <div class="imgClue">
        <img
          v-show='!clue1light'
          src="../assets/images/insects/clue1.png"
        >
        <img
          v-show='clue1light'
          src="../assets/images/insects/clue1_light.png"
        >
      </div>
      <div class="imgClue">
        <img
          v-show='!clue2light'
          src="../assets/images/insects/clue2.png"
        >
        <img
          v-show='clue2light'
          src="../assets/images/insects/clue2_light.png"
        >
      </div>
      <div class="imgClue">
        <img
          v-show='!clue3light'
          src="../assets/images/insects/clue3.png"
        >
        <img
          v-show='clue3light'
          src="../assets/images/insects/clue3_light.png"
        >
      </div>
      <div class="imgClue">
        <img
          v-show='!clue4light'
          src="../assets/images/insects/clue4.png"
        >
        <img
          v-show='clue4light'
          src="../assets/images/insects/clue4_light.png"
        >
      </div>
      <div class="imgFinish">
        <img
          v-show='!cluelight'
          src="../assets/images/insects/btn_unfinished.png"
        >
        <img
          class="btnfinished"
          @click="finished"
          v-show='cluelight'
          src="../assets/images/insects/btn_finished.png"
        >
      </div>
    </div>
    <quesList
      v-show='quesShow'
      @quesReady='quesReady'
      :quesItem='quesItem'
      @correct='correct'
      @errorAnswer='errorAnswer'
      @close='close'
    />
    <login
      v-show='loginFlag'
      @loginReady='loginReady'
      @successLogin='successLogin'
      @closeLogin='closeLogin'
    />
    <div
      v-show="cutText"
      class="cutText"
    >
      <span class="cutTextSpan"></span>
    </div>
    <div
      v-show="ansMask"
      class="ansMask"
      @click="ansMaskNone"
    >
      <img
        v-show="!correctActive==0"
        src="../assets/images/insects/right_tip.png"
        alt=""
      >
      <img
        v-show="correctActive==0"
        src="../assets/images/insects/error_tip.png"
        alt=""
      >
    </div>
    <img
      v-show="foamRubber"
      src="../assets/images/right.mp3"
    >
    <img
      v-show="foamRubber"
      src="../assets/images/error.mp3"
    >
    <audio
      id="rightMp3"
      src="../assets/images/right.mp3"
      preload=""
    ></audio>
    <audio
      id="errorMp3"
      src="../assets/images/error.mp3"
      preload=""
    ></audio>
  </div>



<!-- 结果页 -->
<div v-show="resultPage" class="container">
        <div class="result">
            <div class="detail">
                <img
                    class="img_ant"
                    src="../assets/images/insects/img_ant.png"
                >
                <img
                    class="words"
                    src="../assets/images/insects/words.png"
                >
            </div>
            <div class="code"><img src="../assets/images/insects/password.png"></div>
            <div class="medal"><img src="../assets/images/insects/words02.png"></div>
            <div class="btns">
                <img
                    @click="replay"
                    src="../assets/images/insects/btn_replay.png"
                >
                <img
                    @click="convert2img"
                    src="../assets/images/insects/btn_share.png"
                >
            </div>
        </div>

        <!-- 分享 -->
        <div
            class="share"
            id="share"
        >
            <div class="stone_logo"><img src="../assets/images/insects/stone_logo.png"></div>
            <div class="done">
                <h2>恭喜你成为 <span>HZ{{code}}</span> 号探员！</h2>
                <h2>你出色地完成了这次混知调查局的<br>昆虫大发现任务！ <br>特此颁发荣誉徽章。</h2>
            </div>
            <div class="listen"><img src="../assets/images/insects/qrcode.png"></div>
            <p>扫码免费收听21集昆虫大发现音频课程</p>
        </div>
        <div
            v-show="shareImgFlag"
            class="shareImgBox"
        >
            <div class="shareContend">
                <div
                    class='mackClose'
                    @click="closeShare"
                ><img src="../assets/images/insects/btn_close.png"></div>
                <p>长按图片保存至相册，快去分享吧！</p><img
                    :src="shareImg"
                    crossOrigin="anonymous"
                />
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Typed from "typed.js";
import quesList from "../components/ques.vue";
import login from "../components/login.vue";
import { setTimeout } from "timers";
import wxapi from "../utils/wxapi.js";
import html2canvas from "../utils/html2canvas";
export default {
  components: {
    quesList,
    login,
  },
  data() {
    return {
      indexPage:true,
      resultPage:false,
      loading: true,
      acive: 1,
      glassActive: 0,
      cluelight: false,
      clue1light: false,
      clue2light: false,
      clue3light: false,
      clue4light: false,
      tipFlag: true,
      tipTvFlag: false,
      tvFlag: false,
      tvNews: false,
      tipErrorFlag: false,
      quesItem: {},
      ques: [
        {
          id: 1,
          title: "窗户破了，在玻璃碎片上检测出了鳞片残留，会是哪种昆虫的呢？",
          result: "b",
        },
        {
          id: 2,
          title: "地上有一滩水迹，什么昆虫 喜欢生活在水边呢？",
          result: "c",
        },
        {
          id: 3,
          title: "这副向日葵画框上检测出了花粉，什么昆虫会给花授粉呢？",
          result: "a",
        },
        {
          id: 4,
          title: "仔细回忆一下，被抓的蚜虫是什么昆虫的好伙伴呢？",
          result: "d",
        },
      ],
      quesShow: false,
      correctActive1: 0,
      correctActive2: 0,
      correctActive3: 0,
      correctActive4: 0,
      correctActive: 0,
      loginFlag: false,
      timer: null, // 定时器
      loginReadyFlag: false,
      quesReadyFlag: false,
      shakeFlag: false,
      cutText: false,
      typed01: null,
      typed02: null,
      typed03: null,
      typed04: null,
      typed05: "",
      typed: null,
      musicPause: false,
      media: null,
      rightMp: null,
      errorMp: null,
      foamRubber: false,
      errorStr:
        "再仔细调查一下混知调查局的<br>档案和音频情报！<br><span>点击放大镜</span>，重新答题！",
      ansMask: false,
      code: "",
      shareImg: "",
      shareImgFlag: false,
    };
  },
  created() {
    const that = this;
    that.timer = setInterval(function() {
      console.log(document.readyState);
      if (document.readyState === "complete") {
        console.log("完成");
        console.log(that.timer);
        that.loading = false;
        that.printGuide();
        window.clearInterval(that.timer);
      }
    }, 1000);
    if(localStorage.getItem("userInfo")!=null){
      console.log("getid")
      this.getId();
    }
    
  },
  mounted() {
    wxapi.wxRegister(this.wxRegCallback);
    this.media = document.getElementById("media");
    this.rightMp = document.getElementById("rightMp3");
    this.errorMp = document.getElementById("errorMp3");
    const that = this;
    this.$nextTick(function() {
      that.toPlay();
    });
  },
  methods: {
    ansMaskNone() {
      this.ansMask = false;
    },
    //手动音乐播放
    toPlay() {
      let that = this;
      var state = 0;
      document.addEventListener(
        "touchstart",
        function() {
          if (state == 0) {
            that.media.play();
            that.musicPause = false;
            state = 1;
          }
        },
        false
      );
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          that.media.play();
          that.musicPause = false;
        },
        false
      );
      //循环播放
      that.media.onended = function() {
        that.media.load();
        that.media.play();
        that.musicPause = false;
      };
    },
    musicPlay() {
      if (!this.musicPause) {
        this.musicPause = true;
        this.media.pause();
      } else {
        this.musicPause = false;
        this.media.play();
      }
    },
    shake() {
      this.shakeFlag = true;
      let that = this;
      setTimeout(function() {
        that.shakeFlag = false;
        console.log(111);
      }, 2000);
    },
    successLogin(val) {
      if (val) {
        this.quesShow = true;
        this.quesItem = this.ques[0];
        this.getId();
      }
    },
    loginReady() {
      this.loginReadyFlag = true;
    },
    quesReady() {
      this.quesReadyFlag = true;
    },
    close() {
      this.quesShow = false;
    },
    question(value) {
      let token = localStorage.getItem("token");
      if (!token) {
        this.loginFlag = true;
      } else {
        this.quesShow = true;
        this.quesItem = this.ques[value];
      }
    },
    errorAnswer() {
      this.ansMask = true;
      this.tipFlag = false;
      this.tipErrorFlag = true;
      this.correctActive = 0;
      // this.print(5);
      // this.printError()

      this.errorMp.play();
      if (this.glassActive == 4) {
        this.tipTvFlag = false;
      }
    },
    correct(value) {
      this.correctActive = value;
      this.tipFlag = false;
      this.tipErrorFlag = false;
      this.ansMask = true;
      this.rightMp.play();
      if (value == 1) {
        this.glassActive = 0;
        this.correctActive1 = value;
        this.clue1light = true;
        this.print(1);
      }
      if (value == 2) {
        this.glassActive = 0;
        this.correctActive2 = value;
        this.clue2light = true;
        this.print(2);
      }
      if (value == 3) {
        this.correctActive3 = value;
        this.clue3light = true;
        this.glassActive = 0;
        this.print(3);
      }
      if (value == 4) {
        this.tvNews = false;
        this.tvFlag = false;
        this.glassActive = 0;
        this.correctActive4 = value;
        this.clue4light = true;
        this.tipTvFlag = false;
        this.print(4);
      }
    },
    tvBox() {
      this.tvFlag = true;
      this.tipTvFlag = true;
      this.glassActive = 4;
      this.correctActive = 0;
      this.tipErrorFlag = false;
    },
    closeLogin() {
      this.loginFlag = false;
    },
    finished() {
      this.cutText = true;
      let that = this;
      this.typed = new Typed(".cutTextSpan", {
        strings: [
          "<p>在混知调查局的严格盘问下，<br>蚜虫终于交代了案件真相。<br>原来，真正盗走藏品的昆虫是</p><br><h3>蚂蚁！！！</h3>",
        ],
        typeSpeed: 80,
        startDelay: 50,
        contentType: "html",
        onComplete: function(e) {
          console.log("打印成功，返回参数:", e);
          setTimeout(() => {
            // window.location.href="/cms/ActivityResult";
            // that.$router.replace("/cms/ActivityResult");
            that.indexPage=false;
            that.resultPage=true;
          }, 1000);
        },
      });
      console.log(this.typed);
    },
    printGuide() {
      let that = this;
      let typedGuide = new Typed(".typedGuide", {
        strings: [
          "这里是昆虫市博物馆，<br />集齐4个线索还原案件真相，<br />就能获得开盒密码！<br><span class='redColor'>点击放大镜</span>，开始搜集线索吧！",
        ],
        typeSpeed: 80,
        startDelay: 50,
        contentType: "html",
        onComplete: function(e) {
          console.log("打印成功，返回参数:", e);
          that.glassActive = 1;
        },
      });
      console.log(typedGuide);
    },
    print(value) {
      let that = this;
      if (value == 1) {
        this.typed01 = new Typed(".answer01", {
          strings: [
            "不错！蝴蝶的翅膀上其实分布着<br>五颜六色的鳞片，<br>因此才会光彩夺目。<br><span class='redColor'>点击放大镜</span>，寻找下一个线索！",
          ],
          typeSpeed: 80,
          startDelay: 50,
          contentType: "html",
          onComplete: function(e) {
            console.log("打印成功，返回参数:", e);
            that.glassActive = 2;
          },
        });
      }
      if (value == 2) {
        this.typed02 = new Typed(".answer02", {
          strings: [
            "蜻蜓小时候叫作“水虿”，<br>会在水中生活很长时间才上岸。<br><span class='redColor'>点击放大镜</span>，寻找下一个线索！",
          ],
          typeSpeed: 80,
          startDelay: 50,
          contentType: "html",
          onComplete: function(e) {
            console.log("打印成功，返回参数:", e);
            that.glassActive = 3;
          },
        });
      }
      if (value == 3) {
        this.typed03 = new Typed(".answer03", {
          strings: [
            "蜜蜂完全以花粉、花蜜为食，同时也帮助花朵授粉。<br><span class='redColor'>突发新闻！</span>快点击看看！",
          ],
          typeSpeed: 80,
          startDelay: 50,
          contentType: "html",
          onComplete: function(e) {
            console.log("打印成功，返回参数:", e);
            that.tvNews = true;
          },
        });
      }
      if (value == 4) {
        this.typed04 = new Typed(".answer04", {
          strings: [
            "蚂蚁为了喝上好吃的“蜜露”，<br>常常会饲养、保护蚜虫。<br>经过审讯，蚜虫终于供出了疑犯！<br>点击<span class='redColor'>案件还原！</span>看看真相吧！",
          ],
          typeSpeed: 80,
          startDelay: 50,
          contentType: "html",
          onComplete: function(e) {
            console.log("打印成功，返回参数:", e);
            that.cluelight = true;
          },
        });
      }
    },
    printError() {
      let str = this.errorStr;
      let typed05 = new Typed(".answer05", {
        strings: [str],
        typeSpeed: 80,
        startDelay: 50,
        contentType: "html",
        onComplete: function(e) {
          console.log("打印成功，返回参数:", e);
          typed05.stop();
        },
      });
      console.log(typed05);
    },
     closeShare() {
      this.shareImgFlag = false;
    },
    convert2img() {
      // if(localStorage.getItem('imgUrl')){
      //     this.shareImgFlag=true;
      //    this.shareImg=localStorage.getItem('imgUrl');
      // }else{
      // Toast.loading({
      //     message: '加载中...',
      //     forbidClick: true,
      //     duration: 0,
      // });
      let that = this;
      let $share = document.querySelector("#share");
      (window.html2canvas || html2canvas)($share, {
        allowTaint: true,
        taintTest: false,
        scale: 2,
        useCORS: true,
        width: $share.offsetWidth,
        height: $share.offsetHeight,
      }).then(function(canvas) {
        // img为base64格式的图片
        let img = canvas.toDataURL("image/jpeg", 1.0);
        that.shareImgFlag = true;
        that.shareImg = img;
        // console.log(img)
        // let img =canvas.toDataURL("image/png");
        // that.upladImg(img)
      });
      // }
    },
    getId() {
      let id = JSON.parse(localStorage.getItem("userInfo")).id + "";
      if (id.length == 1) {
        this.code = "0000" + id;
      } else if (id.length == 2) {
        this.code = "000" + id;
      } else if (id.length == 3) {
        this.code = "00" + id;
      } else if (id.length == 4) {
        this.code = "0" + id;
      } else {
        this.code = id;
      }
    },
    replay() {
      window.location.reload();
      // this.$router.replace("/cms/Activity");
    },
    //分享功能
    wxRegCallback() {
      // 用于微信JS-SDK回调
      this.wxShareTimeline();
      this.wxShareAppMessage();
    },
    wxShareTimeline() {
      // 微信自定义分享到朋友圈
      let option = {
        title: "昆虫博物馆大调查！跟混局长一起回到案发现场寻找线索吧！", // 分享标题, 请自行替换
        link: "http://m.hunzhi.com/cms/activity?id=1", //window.location.href.split('?')[0]+'#/callup'+'?'+window.location.href.split('?')[1].split('#')[0]// 分享链接，根据自身项目决定是否需要split
        imgUrl:
          "http://hunzhi-app-static.oss-cn-shanghai.aliyuncs.com/kunchongdiaocha.jpeg", // 分享图标, 请自行替换，需要绝对路径
        success: () => {},
        error: () => {},
      };
      // 将配置注入通用方法
      wxapi.ShareTimeline(option);
    },
    wxShareAppMessage() {
      // 微信自定义分享给朋友
      let option = {
        title: "昆虫博物馆大调查！", // 分享标题, 请自行替换
        desc: "跟混局长一起回到案发现场寻找线索吧！", // 分享描述, 请自行替换
        link: "http://m.hunzhi.com/cms/activity?id=1", //window.location.href.split('?')[0]+'#/callup'+'?'+window.location.href.split('?')[1].split('#')[0] // 分享链接，根据自身项目决定是否需要split
        imgUrl:
          "http://hunzhi-app-static.oss-cn-shanghai.aliyuncs.com/kunchongdiaocha.jpeg", // 分享图标, 请自行替换，需要绝对路径
        success: () => {},
        error: () => {},
      };
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option);
    },
  },
};
</script>

<style scoped>
#rightMp3 {
  display: none;
}
#errorMp3 {
  display: none;
}
.loading {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: #ffd359;
  background-image: url("../assets/images/insects/loadingbg.png");
  background-size: 366px 343px;
  background-repeat: repeat;
}
.loading .activityTitle {
  width: 460px;
  height: 171px;
  margin: 0 auto;
  margin-top: 462px;
}
.loading .activityTitle img {
  width: 100%;
  height: 100%;
}
.loading .box {
  display: inline-block;
  height: 200px;
  width: 484px;
  position: relative;
  transition: all 0.2s ease;
}
#music {
  position: absolute;
  right: 10%;
  top: 10%;
  width: 82px;
  height: 82px;
  z-index: 3;
}
#music img {
  width: 100%;
  height: 100%;
}
.rotate {
  -webkit-animation: rotating 1.2s linear infinite;
  -moz-animation: rotating 1.2s linear infinite;
  -o-animation: rotating 1.2s linear infinite;
  animation: rotating 1.2s linear infinite;
}

.cutText {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  z-index: 10;
  text-align: center;
}
.pageContainer{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.activity {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/images/insects/newBg.png") no-repeat;
  background-size: 100% auto;
}
.about {
  position: absolute;
  width: 100%;
  height: 427px;
  top: 45%;
  left: 0;
  background: url("../assets/images/insects/imgCp.png") no-repeat;
  background-size: 100% 100%;
  margin-top: -203px;
}
.btnfinished {
  animation: zy 1.5s 0.05s linear infinite;
  -moz-animation: zy 1.5s 0.05s linear infinite; /* Firefox */
  -webkit-animation: zy 1.5s 0.05s linear infinite; /* Safari and Chrome */
  -o-animation: zy 1.5s 0.05s linear infinite; /* Opera */
}
.tvBox {
  width: 245px;
  height: 250px;
  position: absolute;
  left: 262px;
  top: 50px;
  z-index: 1;
  animation: zy 1.5s 0.05s linear infinite;
  -moz-animation: zy 1.5s 0.05s linear infinite; /* Firefox */
  -webkit-animation: zy 1.5s 0.05s linear infinite; /* Safari and Chrome */
  -o-animation: zy 1.5s 0.05s linear infinite; /* Opera */
}
.tvBox img {
  width: 100%;
  height: 100%;
}
.magnifglass {
  position: absolute;
  width: 170px;
  height: 184px;
}
.magnifglass img,
.glassPlace01 img {
  width: 100%;
  height: 100%;
}
.glassPlace01 {
  position: fixed;
  width: 170px;
  height: 184px;
  left: 300px;
  top: 300px;
  -webkit-animation: balloon1 2.5s ease-in-out infinite;
  -moz-animation: balloon1 2.5s ease-in-out infinite;
  -o-animation: balloon1 2.5s ease-in-out infinite;
  animation: balloon1 2.5s ease-in-out infinite;
}
.glassPlace02 {
  left: 70px;
  top: 120px;
  -webkit-animation: balloon1 2.5s ease-in-out infinite;
  -moz-animation: balloon1 2.5s ease-in-out infinite;
  -o-animation: balloon1 2.5s ease-in-out infinite;
  animation: balloon1 2.5s ease-in-out infinite;
}
.glassPlace03 {
  right: 30px;
  top: 120px;
  -webkit-animation: balloon1 2.5s ease-in-out infinite;
  -moz-animation: balloon1 2.5s ease-in-out infinite;
  -o-animation: balloon1 2.5s ease-in-out infinite;
  animation: balloon1 2.5s ease-in-out infinite;
}
.glassPlace04 {
  left: 317px;
  top: 30px;
  z-index: 3;
  -webkit-animation: balloon1 2.5s ease-in-out infinite;
  -moz-animation: balloon1 2.5s ease-in-out infinite;
  -o-animation: balloon1 2.5s ease-in-out infinite;
  animation: balloon1 2.5s ease-in-out infinite;
}
.rightIcon {
  width: 115px;
  height: 122px;
  position: absolute;
}
.rightIcon img,
.rightPlace01 img {
  width: 100%;
  height: 100%;
}
.rightPlace01 {
  position: fixed;
  width: 115px;
  height: 122px;
  right: 232px;
  top: 240px;
}
.rightPlace02 {
  left: 167px;
  top: 84px;
}
.rightPlace03 {
  right: 70px;
  top: 100px;
}
.rightPlace04 {
  right: 267px;
  top: 190px;
}
.activityTipBox {
  position: absolute;
  bottom: 157px;
  left: 0;
  width: 100%;
  z-index: 4;
}
.activieContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.activieContainer .activieTip {
  width: 538px;
  height: 307px;
  background: url("../assets/images/insects/dialogue.png") no-repeat;
  background-size: contain;
  text-align: center;
}
.activieContainer .activieTip .tip {
  margin: 60px;
  font-size: 26px;
  color: #241f1e;
  line-height: 46px;
}
.activieContainer .activieTip .correctTip {
  margin: 60px;
  font-size: 26px;
  color: #488697;
}

.activieContainer .activieTip .tip span.answer06 span,
.redColor {
  color: #fe5838;
  font-size: 26px;
}
.answer05 {
  display: inline-block;
}
.answer_error {
  width: 154px;
  height: 43px;
}
.activieContainer .activieHunzi {
  width: 147px;
  height: 233px;
}
.activieContainer .activieHunzi img {
  width: 100%;
  height: 100%;
}
.activity .bottomBox {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 157px;
  background: #2b3546;
  opacity: 0.86;
  display: flex;
  justify-content: center;
  align-items: center;
}
.activity .bottomBox .imgClue {
  width: 124px;
  height: 124px;
}
.activity .bottomBox .imgClue img {
  width: 100%;
  height: 100%;
}
.activity .bottomBox .imgFinish {
  width: 234px;
  height: 127px;
  position: relative;
}
.activity .bottomBox .imgFinish img {
  position: absolute;
  width: 234px;
  height: 127px;
  left: 0;
  top: 0;
}
.tvMask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2;
  text-align: center;
}
.tvMask .news {
  margin-top: 310px;
  display: inline-block;
  width: 651px;
  height: 422px;
}
.ansMask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 3;
  text-align: center;
}
.ansMask img {
  width: 506px;
  height: 212px;
  margin: 0 auto;
  margin-top: 320px;
  animation: jiggle 2s ease-in infinite;
}
/*音乐播放 */
@-webkit-keyframes rotating {
  from {
    -webkit-transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes rotating {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-moz-keyframes rotating {
  from {
    -moz-transform: rotate(0);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
/* 如果光标没出现，而是出现在下一行，那么就是盒子是块级标签，必须得转换成行内标签 */
/* 想让的光标闪动的话，复制下面的代码 */
.typed-cursor {
  opacity: 1;
  animation: typedjsBlink 0.7s infinite;
  -webkit-animation: typedjsBlink 0.7s infinite;
  animation: typedjsBlink 0.7s infinite;
}
@keyframes typedjsBlink {
  50% {
    opacity: 0;
  }
}
@-webkit-keyframes typedjsBlink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.typed-fade-out {
  opacity: 0;
  transition: opacity 0.25s;
  -webkit-animation: 0;
  animation: 0;
}
/*BALLOON 1 4*/
@-webkit-keyframes balloon1 {
  0% {
    -webkit-transform: translateY(0) rotate(0deg);
  }
  25% {
    -webkit-transform: translateX(62px);
  }
  50% {
    -webkit-transform: translateX(62px) translateY(62px);
  }
  50.1% {
    -webkit-transform: translateX(62px) translateY(62px);
  }
  75% {
    -webkit-transform: translateX(0px) translateY(62px);
  }
  100% {
    -webkit-transform: rotate(-360deg);
  }
}
@-moz-keyframes balloon1 {
  0% {
    -moz-transform: translateY(0) rotate(0deg);
  }
  25% {
    -moz-transform: translateX(62px);
  }
  50% {
    -moz-transform: translateX(62px) translateY(62px);
  }
  50.1% {
    -moz-transform: translateX(62px) translateY(62px);
  }
  75% {
    -moz-transform: translateX(0px) translateY(62px);
  }
  100% {
    -moz-transform: rotate(-360deg);
  }
}
@-o-keyframes balloon1 {
  0% {
    -o-transform: translateY(0) rotate(0deg);
  }
  25% {
    -o-transform: translateX(62px);
  }
  50% {
    -o-transform: translateX(62px) translateY(62px);
  }
  50.1% {
    -o-transform: translateX(62px) translateY(62px);
  }
  75% {
    -o-transform: translateX(0px) translateY(62px);
  }
  100% {
    -o-transform: rotate(-360deg);
  }
}
@keyframes balloon1 {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateX(62px);
  }
  50% {
    transform: translateX(62px) translateY(62px);
  }
  50.1% {
    transform: translateX(62px) translateY(62px);
  }
  75% {
    transform: translateX(0px) translateY(62px);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@-webkit-keyframes zy {
  10% {
    transform: rotate(15deg) scale(1);
  }
  20% {
    transform: rotate(-10deg) scale(1.1);
  }
  30% {
    transform: rotate(5deg) scale(1);
  }
  40% {
    transform: rotate(-5deg) scale(1.1);
  }
  50%,
  100% {
    transform: rotate(0deg) scale(1);
  }
}
@-moz-keyframes zy {
  10% {
    transform: rotate(15deg) scale(1);
  }
  20% {
    transform: rotate(-10deg) scale(1.1);
  }
  30% {
    transform: rotate(5deg) scale(1);
  }
  40% {
    transform: rotate(-5deg) scale(1.1);
  }
  50%,
  100% {
    transform: rotate(0deg) scale(1);
  }
}
@-o-keyframes zy {
  10% {
    transform: rotate(15deg) scale(1);
  }
  20% {
    transform: rotate(-10deg) scale(1.1);
  }
  30% {
    transform: rotate(5deg) scale(1);
  }
  40% {
    transform: rotate(-5deg) scale(1.1);
  }
  50%,
  100% {
    transform: rotate(0deg) scale(1);
  }
}
@keyframes zy {
  10% {
    transform: rotate(15deg) scale(1);
  }
  20% {
    transform: rotate(-10deg) scale(1.1);
  }
  30% {
    transform: rotate(5deg) scale(1);
  }
  40% {
    transform: rotate(-5deg) scale(1.1);
  }
  50%,
  100% {
    transform: rotate(0deg) scale(1);
  }
}

/* -------------- loader4 -------------- */

.loader4 {
  position: relative;
  width: 484px;
  height: 28px;
  border-radius: 28px;
  border: 2px solid #ffffff;
  top: 45%;
  top: -webkit-calc(50% - 10px);
  top: calc(50% - 10px);
  left: 25%;
  left: -webkit-calc(50% - 75px);
  left: calc(50% - 75px);
  background-color: #ffc164;
}

.loader4:before {
  content: "";
  position: absolute;
  background-color: #2bb5c9;
  top: 1px;
  left: 1px;
  height: 22px;
  border-radius: 22px;
  width: 0px;
  z-index: 0;
  opacity: 1;
  -webkit-transform-origin: 100% 0%;
  transform-origin: 100% 0%;
  -webkit-animation: loader4 10s ease-in-out infinite;
  animation: loader4 10s ease-in-out infinite;
}

.loader4:after {
  content: "加载中 ...";
  color: #fff;
  font-family: Lato, "Helvetica Neue";
  font-weight: 200;
  font-size: 26px;
  position: absolute;
  width: 100%;
  height: 20px;
  line-height: 20px;
  left: 180px;
  top: 60px;
}

@-webkit-keyframes loader4 {
  0% {
    width: 0px;
  }
  70% {
    width: 100%;
    opacity: 1;
  }
  90% {
    opacity: 0;
    width: 100%;
  }
  100% {
    opacity: 0;
    width: 0px;
  }
}

@keyframes loader4 {
  0% {
    width: 0px;
  }
  70% {
    width: 100%;
    opacity: 1;
  }
  90% {
    opacity: 0;
    width: 100%;
  }
  100% {
    opacity: 0;
    width: 0px;
  }
}
.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

@keyframes jiggle {
  48%,
  62% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 0.9);
  }
  56% {
    transform: scale(0.9, 1.1) translate(0, -10px);
  }
  59% {
    transform: scale(1, 1) translate(0, -8px);
  }
}
@media (max-width: 750px) {
  .activity {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.shareImgBox {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 3;
  text-align: center;
}
.shareImgBox img {
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}
.shareContend {
  width: 60%;
  margin: 0 auto;
  margin-top: 100px;
  background: #fff9df;
  padding: 10px;
  border-radius: 10px;
  position: relative;
}
.shareContend .mackClose {
  width: 64px;
  height: 64px;
  position: absolute;
  right: -30px;
  top: -30px;
}
.shareContend .mackClose img {
  width: 100%;
  height: 100%;
}
.shareContend p {
  color: #444444;

  font-size: 26px;
}
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.result {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: #fde3b7;
}
.result .detail {
  position: relative;
  height: 520px;
}
.result .detail .img_ant {
  width: 400px;
  height: 400px;
  position: absolute;
  left: 20px;
  top: 100px;
}
.result .detail .words {
  width: 360px;
  height: 377px;
  position: absolute;
  right: 20px;
  top: 40px;
  z-index: 1;
}
.result .code {
  text-align: center;
}
.result .code img {
  width: 526px;
  height: 262px;
}
.medal {
  width: 619px;
  height: 212px;
  margin: 40px auto 0 auto;
}
.medal img {
  width: 100%;
  height: 100%;
}
.btns {
  margin-top: -15px;
  display: flex;
  justify-content: center;
}
.btns img {
  width: 376px;
  height: 131px;
}

.share {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: url("../assets/images/insects/bg03.jpg");
  background-size: 100% 100%;
  text-align: center;
}
.share .stone_logo {
  text-align: center;
}
.share .stone_logo img {
  margin-top: 65px;
  width: 500px;
  height: 501px;
}
.done {
  margin-top: 20px;
}
.done h2 {
  color: #ecbc68;
  font-size: 34px;
  line-height: 60px;
}
.done h2 span {
  color: #ffffff;
}
.listen img {
  width: 223px;
  height: 271px;
}
.share p {
  margin-top: 20px;
  font-size: 26px;
  color: #fbe3b8;
}
</style>
